// For every unique number a scan finds, ask the server once whether it may be
// listed (core/devices/scanVisibility). All at once, no cap; once per number per
// screen visit.
//
// -> { verdicts: { [uno]: verdict | null }, recheck(uno) }   null = still asking

import { useCallback, useEffect, useRef, useState } from 'react';
import { lookupScanVerdict } from '../devices/scanVisibility';

export default function useScanVerdicts(uniqueNumbers) {
  const [verdicts, setVerdicts] = useState({});
  const asked = useRef(new Set());
  const alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    return () => { alive.current = false; };
  }, []);

  const recheck = useCallback(async (uno) => {
    asked.current.add(uno);
    setVerdicts((m) => ({ ...m, [uno]: null }));
    const v = await lookupScanVerdict(uno);
    if (alive.current) setVerdicts((m) => ({ ...m, [uno]: v }));
  }, []);

  const key = (uniqueNumbers || []).filter(Boolean).join(',');
  useEffect(() => {
    if (!key) return;
    key.split(',').filter((u) => !asked.current.has(u)).forEach(recheck);
  }, [key, recheck]);

  return { verdicts, recheck };
}
